/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * pinned {boolean} Pin the column
 * align {string} Column content alignment
 */
export default [
  {
    id: 1,
    label: 'School Name',
    field_name: 'school_name',
    source_field: 'school_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'District',
    field_name: 'district_name',
    source_field: 'district_name',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Teachers Enrolled',
    field_name: 'teacher_count',
    source_field: 'teacher_count',
    showColumn: true,
    align: 'center',
  },
  {
    id: 4,
    label: 'Students Enrolled',
    field_name: 'student_count',
    source_field: 'student_count',
    showColumn: true,
    align: 'center',
  },
  {
    id: 5,
    label: 'Classes Created',
    field_name: 'class_count',
    source_field: 'class_count',
    showColumn: true,
    align: 'center',
  },
];
